import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Box } from '@mui/material';

import { DocumentBase } from '../order-details/tabs/SettlementTab/documents/DocumentBase';

export default function IssueReceipt({ order, open, handleClose }) {
  const { season, module } = useSelector(state => state.app);

  return (

    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box>
        <DocumentBase closeDialog={handleClose} type={{ name: 'Paragon', code: 5 }} order={order} season={season} module={module} submitCallback={(a, b) => {}}/>
      </Box>
    </Modal>
  );
}
